export default __webpack_public_path__ + "static/media/resume.f5c54c99.pdf";